import firebase from 'firebase/app';
import { notification } from 'antd';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

import FirebaseConfigType from 'constants/firebaseConfigType';

const firebaseEnviroment = process.env.REACT_APP_FIREBASE_ENVIRONMENT;
const client = process.env.REACT_APP_CLIENT;

const firebaseConfig = FirebaseConfigType[firebaseEnviroment][client];

firebase.initializeApp(firebaseConfig);

export const firebaseAuth = firebase.auth();
export const firebaseDatabase = firebase.database();
export const firebaseFirestore = firebase.firestore();
export const firebaseStorage = firebase.storage();
export const firebaseFunctions = firebase.functions();

export const baseUrl = process.env.REACT_APP_FIREBASE_API_URL;

export async function login(email, password) {
  return firebaseAuth
    .signInWithEmailAndPassword(email, password)
    .then(() => true)
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      });
    });
}

export async function register(email, password, name) {
  return firebaseAuth
    .createUserWithEmailAndPassword(email, password)
    .then(response => {
      if (response.user) {
        const { uid } = response.user;
        firebaseDatabase
          .ref('users')
          .child(uid)
          .set({
            role: 'admin',
            name,
          });
      }
      return true;
    })
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.message,
      });
    });
}

export async function currentAccount() {
  let userLoaded = false;
  function getCurrentUser(auth) {
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebaseAuth.currentUser);
      }
      const unsubscribe = auth.onAuthStateChanged(user => {
        userLoaded = true;
        unsubscribe();
        const getUserData = async () => {
          if (user) {
            return Object.assign(user, {
              id: user.uid,
              name: 'Patos',
              role: 'admin',
              avatar: '',
            });
          }
          return user;
        };
        resolve(getUserData());
      }, reject);
    });
  }
  return getCurrentUser(firebaseAuth);
}

export async function isUserAdmin() {
  const result = await firebaseAuth.currentUser.getIdTokenResult(true);
  return !!result.claims.admin;
}

export async function logout() {
  return firebaseAuth.signOut().then(() => true);
}
